import { generateId, YooptaPlugin } from "@yoopta/editor";
import { GameTitleCommands } from "../commands/index.js";
import { GameTitleRender } from "../ui/GameTitle.js";

const GameTitle = new YooptaPlugin({
  type: "GameTitle",
  elements: {
    gameTitle: {
      render: GameTitleRender,
      props: {
        nodeType: "void",
        readOnly: true,
      },
    },
  },
  commands: GameTitleCommands,
  options: {
    display: {
      title: "Game Title",
      description: "Automatically displays the current game's title",
    },
  },
  parsers: {
    html: {
      deserialize: {
        nodeNames: ["DIV"],
        parse: (el, editor) => {
          if (el.getAttribute("data-game-title")) {
            const props = {
              nodeType: "void",
              readOnly: true,
            };

            const node = {
              id: generateId(),
              type: "gameTitle",
              children: [{ text: "" }],
              props,
            };

            return node;
          }
        },
      },
      serialize: (element, text, blockMeta) => {
        const { align = "left", depth = 0 } = blockMeta || {};
        return `<div data-game-title="true" style="margin-left: ${depth * 20}px; text-align: ${align};">
          <h2 class="game-title-block">[Game Title]</h2>
        </div>`;
      },
    },
    markdown: {
      serialize: (element, text) => {
        return `## [Game Title]\n`;
      },
    },
    email: {
      serialize: (element, text, blockMeta) => {
        const { align = "left", depth = 0 } = blockMeta || {};
        return `
          <table style="width:100%;">
            <tbody style="width:100%;">
              <tr>
                <td style="margin-left: ${depth * 20}px; text-align: ${align}; margin-top: 1rem;">
                  <h2 style="margin: 0; font-size: 24px; font-weight: bold;">[Game Title]</h2>
                </td>
              </tr>
            </tbody>
          </table>
        `;
      },
    },
  },
});

export { GameTitle };
